External-run diagnosis is a customer-accessible workflow. It requires a normal
Cofactor login with external-run read access; it does not require psql, Sentry,
AWS, Redis, or superadmin commands.

Start with:

  cofactor external-run get <run-id>
  cofactor external-run failures <run-id>
  cofactor external-run skips <run-id>
  cofactor external-run debug overview <run-id>

Use the result rows to answer what the test framework observed. Use lifecycle
telemetry to answer whether the harness timed out, retried, or recovered. Use
artifacts and a focused rerun to distinguish an application bug from a test or
harness issue.

The CLI reports evidence; it does not pretend to make an AI diagnosis in the
cloud. A developer or local coding agent can inspect the materialized workspace
alongside the customer's test source and application source.
